import { Snackbar, Alert, alpha, useTheme, Slide } from "@mui/material";
import { useApplicationContext } from "../../context/ApplicationContext";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";

function SlideLeftTransition(props) {
  return <Slide {...props} direction="right" />;
}

const GlobalSnackbar = () => {
  const { globalSnackbar, setGLobalSnackBar } = useApplicationContext();
  const theme = useTheme();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setGLobalSnackBar({ open: false, title: "", severity: "" });
  };

  const getIcon = () => {
    switch (globalSnackbar.severity?.toLowerCase()) {
      case "success":
        return <CheckCircleIcon />;
      case "error":
        return <ErrorIcon />;
      case "warning":
        return <WarningIcon />;
      default:
        return <InfoIcon />;
    }
  };

  const getAlertStyles = () => {
    const isDark = theme.palette.mode === 'dark';
    const severity = globalSnackbar.severity || 'info';

    if (isDark) {
      return {
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        borderLeft: `4px solid ${theme.palette[severity].main}`,
        boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.3)}`,
      };
    }
    
    return {
      backgroundColor: theme.palette[severity].main,
      boxShadow: `0 4px 12px ${alpha(theme.palette[severity].main, 0.3)}`,
    };
  };

  return (
    <Snackbar
      open={globalSnackbar.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      TransitionComponent={SlideLeftTransition}
      sx={{
        bottom: { xs: 16, sm: 24 },
        left: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 'auto' },
      }}
    >
      <Alert
        onClose={handleClose}
        severity={globalSnackbar.severity || "info"}
        icon={getIcon()}
        sx={{
          alignItems: "center",
          width: '100%',
          minWidth: { xs: 'calc(100vw - 32px)', sm: '320px' },
          maxWidth: { xs: 'calc(100vw - 32px)', sm: '480px' },
          borderRadius: '12px',
          padding: '4px 8px',
          ...getAlertStyles(),
          '& .MuiAlert-icon': {
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.mode === 'dark' 
              ? theme.palette[globalSnackbar.severity || 'info'].main
              : theme.palette.common.white,
          },
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            padding: '10px 0',
            color: theme.palette.mode === 'dark' 
              ? theme.palette.text.primary
              : theme.palette.common.white,
          },
          '& .MuiAlert-action .MuiIconButton-root': {
            color: theme.palette.mode === 'dark'
              ? theme.palette.text.secondary
              : alpha(theme.palette.common.white, 0.8),
          },
        }}
      >
        {globalSnackbar.title}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;